export default "__VITE_PUBLIC_ASSET__d54ddb1a__"